window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
      console.log(type);
    }.bind(this));
  }

});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '£{{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    // $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },


    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

theme.ExitIntent = (function() {

    if (window.location.pathname == '/challenge' || window.location.pathname == '/contact' ){
      return false;
    } 

    // Seceltors 
    var selectors = {
        modalActive        : false,
        $modal             : $('#modal'),
        $modalClose        : $('.modal__close-link, .modal__close'),
        modalOpenClass     : 'modal--open',
        cookieName         : '__exit-intent',
        cookieExpire       : 7,
        cookieExpireSignup : 300,
        _delayTimer        : null,
        delayFunction      : $('#modal').attr('data-exit-intent_delay') * 1000 || 0,
        delay              : $('#modal').attr('data-exit-intent_popup_delay') * 1000 || 0,
        _html              : document.documentElement
    };


    function init() {
        contactSubmitted();
        setTimeout(exitIntent, selectors.delayFunction);
    };

    init();

    function exitIntent() {
        console.log('Started...')
        if (isDisabled()) { return; }
        selectors._html.addEventListener('mouseleave', handleMouseleave);
        selectors._html.addEventListener('mouseenter', handleMouseenter);
        selectors._html.addEventListener('keydown', handleKeydown);
        selectors.$modalClose.on('click', modalClose);
    }

    function handleMouseleave(e) {
        if (e.clientY > selectors.sensitivity) { return; }
        selectors._delayTimer = setTimeout(modalOpen, selectors.delay);
    }

    function handleMouseenter() {
        if (selectors._delayTimer) {
          clearTimeout(selectors._delayTimer);
          selectors._delayTimer = null;
        }
      }

    function handleKeydown(e) {
        if (e.keyCode === 27) { modalClose() }
    }

    function isDisabled() {
        return $.cookie(selectors.cookieName);
    }

    function modalClose() {
        selectors.modalActive = false;
        selectors.$modal.hide();
        $.cookie(selectors.cookieName, 'true', { expires: selectors.cookieExpire, path: '/' });
    }

    function modalOpen(container) {
        selectors.modalActive = true;
        selectors.$modal.show();
    }

    // URL Contains /?customer_posted=true
    function contactSubmitted(){
        var name = 'customer_posted'
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null){
          var results = 'false';
        } else {
          var results = results[1] || 0;
        }
        if (results == 'true'){
          $.cookie(selectors.cookieName, 'true', { expires: selectors.cookieExpireSignup, path: '/' });
        } 
    }


})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productSliderVariant: '[data-slick-variant]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$sliderImage = $(selectors.productSliderVariant);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    } else if (this.$sliderImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductSlider.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
    },

    updateProductSlider: function(evt) {
      var variant = evt.variant.id;
      this.$sliderImage = $(selectors.productSliderVariant);

      this.$sliderImage.each(function (index, value) { 
        var slickSlide = $(this).attr('data-slick-variant');
        var slickVar   = parseInt(slickSlide);
        if (slickVar == variant) {
          var slideNo = $(this).attr('data-slick-index');
          $('.main-product-slider').slick('slickGoTo', slideNo);
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Navigation = (function() {

  var $hamburger        = $('#Hamburger'),
      $Header           = $('#Header'),
      $mobileOverlay    = $('.mobile-overlay'),
      $mobileHeader     = $('.mobile-header');

  $($hamburger).on('click', mobileNavigation);

  function mobileNavigation() {
    $('body').toggleClass('js--mobile-menu-open')
  };

  function mobileHideNavigation() {
    $('body').removeClass('js--mobile-menu-open')
  };

  $($mobileOverlay).on('click', mobileHideNavigation);

  return mobileNavigation;
})();

slate.convertEmojis = (function() {

	if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0){
		$("body").html($("body").html().replace(/\:fire\:/g,''));//fire
		$("body").html($("body").html().replace(/\:sunglasses\:/g,''));//sunglasses
		$("body").html($("body").html().replace(/\:palm_tree\:/g,''));//palm tree
		$("body").html($("body").html().replace(/\:rainbow\:/g,''));//rainbow
		$("body").html($("body").html().replace(/\:heart_eyes_cat\:/g,''));//heart eyes cat
		$("body").html($("body").html().replace(/\:100\:/g,''));//100
		$("body").html($("body").html().replace(/\:tropical_fish\:/g,''));//tropical fish
		$("body").html($("body").html().replace(/\:sunny\:/g,''));//sunny
		$("body").html($("body").html().replace(/\:zap\:/g,''));//zap
		return;
	}

	function convertEmoji(str) {
		return str.replace(/\[e-([0-9a-fA-F]+)\]/g, function (match, hex) {
			return String.fromCodePoint(Number.parseInt(hex, 16));
		});
	}

	//console.log(convertEmoji('[e-1f60e]'));
	var $selector = ".rte,a,h1,h2,h3,h4,h5,h6,p";
	$($selector).html(function(index,html){
		return html.replace(/\:fire\:/g,convertEmoji('[e-1f525]'));//fire
	});
	$($selector).html(function(index,html){
		return html.replace(/\:sunglasses\:/g,convertEmoji('[e-1f60e]'));//sunglasses
	});
	$($selector).html(function(index,html){
		return html.replace(/\:palm_tree\:/g,convertEmoji('[e-1F334]'));//palm tree
	});
	$($selector).html(function(index,html){
		return html.replace(/\:rainbow\:/g,convertEmoji('[e-1F308]'));//rainbow
	});
	$($selector).html(function(index,html){
		return html.replace(/\:heart_eyes_cat\:/g,convertEmoji('[e-1F63B]'));//heart eyes cat
	});
	$($selector).html(function(index,html){
		return html.replace(/\:100\:/g,convertEmoji('[e-1F4AF]'));//100
	});
	$($selector).html(function(index,html){
		return html.replace(/\:tropical_fish\:/g,convertEmoji('[e-1F420]'));//tropical fish
	});
	$($selector).html(function(index,html){
		return html.replace(/\:sunny\:/g,convertEmoji('[e-1F31E]'));//sunny
	});
	$($selector).html(function(index,html){
		return html.replace(/\:zap\:/g,convertEmoji('[e-26A1]'));//zap
	});

})();
theme.Meganav = (function() {

  var $siteNavList = $('.site-nav li'),
     $siteDropdown = $('.meganav');

  $siteNavList.on('mouseenter', showMeganav);

  $siteDropdown.on('mouseleave mousedown', function(e) {
    if( e.type != 'mousedown' && e.originalEvent.buttons != 2 ){
      $siteDropdown.removeClass('meganav--show');
    }
  });

  function showMeganav(){
    
      var $this         = $(this),
          $parentId     = $this.data('meganav-parent');

      $siteDropdown.removeClass('meganav--show');

      $siteDropdown.each(function(){
        var $childId = $(this).data('meganav-child');

        if( $parentId == $childId ){
            $(this).addClass('meganav--show');
        }
      });
  }

  function positionArrow(){
    $('.site-nav li[data-meganav-parent]').each(function(){
      var $thisMatch = $(this).data('meganav-parent'),
          $thisWidth = $(this).find("a").innerWidth(),
          $thisPos = $(this).offset().left,
          $newWidth = $thisWidth/2 + $thisPos -15;
      $(".meganav[data-meganav-child='"+$thisMatch+"']").find(".meganav__arrow").css("transform","translateX("+$newWidth+"px)");
    });
  }

  function dupicateNav(){
    $('.meganav').each(function(){
      var $thisList = $(this).find(".meganav__list").html(),
        $thisMatch = $(this).data('meganav-child'),
        $thisColor = $(this).attr("style");

      $(".site-nav li[data-meganav-parent='"+$thisMatch+"']").addClass("has-mobile-menu").append("<div class='medium-up--hide mobile-submenu' style='"+$thisColor+"'>"+$thisList+"</div>");
    });
    $(".has-mobile-menu .down").on("click",function(){
      $(".site-nav li").removeClass("open-menu");
      $(this).parent().parent().toggleClass("open-menu");
      return false;
    });
    $(".has-mobile-menu .up").on("click",function(){
      $(".site-nav li").removeClass("open-menu");
      return false;
    })
  }

  positionArrow();
  dupicateNav();
  $(window).resize(function(){
    positionArrow();
  })

    

})();


theme.MeganavSection = function MeganavSection() {};

theme.MeganavSection.prototype = $.extend({}, theme.MeganavSection.prototype, {
  onBlockSelect: function(e){
    var blockId     = e.detail.blockId;
    $('#Meganav-' + blockId).addClass('meganav--show');
  },
  onBlockDeselect: function() {
    $('.meganav').removeClass('meganav--show');
  }
});
theme.StickNav = (function() {

	var activeClass = 'header-fixed--active',
		$header     = $('.header-fixed') || null;

  	$(window).on('scroll', stickyNavigation);

  	function stickyNavigation() {
  		if ($header.length > 0) {
			var scrollTop        = $(window).scrollTop(),
				headerOffestTop = $header.offset().top;

			if( scrollTop > headerOffestTop ){
				$header.addClass(activeClass);
			} else {
				$header.removeClass(activeClass);
			}
		}
 	}

  return stickyNavigation;

})();



theme.Newsletter = (function() {

	$('#mc-form').ajaxChimp({
	    url: ' LIST NEEDED ',
	    callback: callbackFunction
	});
	 
	function callbackFunction (resp) {
		var respMessage = resp.msg.replace('0 - ','');
		$('.mc-form__result').html(respMessage);
		if (resp.result === 'success') {
		  console.log('success');
		} else if (resp.result === 'error'){
		  console.log('error');
		}
	}

})();
/* ================= Search Popup ================= */
theme.SearchPopup = (function() {

  if($(".site-header__search-icon.full-screen-search").length != 0){
    $(document).on('keydown', function(evt) {
      if (evt.keyCode === 27) {
        $('body > .search-hero').removeClass('search-hero--is-active');  
      }
    });
    $('.search-hero__close').on('click', function(e) {
      $('body > .search-hero').removeClass('search-hero--is-active');
    });
    $('.site-header__search-icon').on('click', function(e) {
      $('body > .search-hero').addClass('search-hero--is-active');
      $( ".search-hero__inner .search__input" ).focus();
      return false;
    });
  }else{
     $('.site-header__search-icon').on('click', function(e) {
      $('header .search-hero').addClass('search-small--is-active');
      $( "header .search-hero__inner .search__input" ).focus();

      return false;
    });

    $('.search-hero__close').on('click', function(e) {
      $('header .search-hero').removeClass('search-small--is-active');
    });
  }


})();

theme.Slideshow = (function() {

	var $slideshow = $('.slideshow');

  function slickRender(){
  	$slideshow.slick(getSliderSettings());
  }

  function getSliderSettings(){
	  return {
	    slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			dots:true
	  }
	}

  function videoSlide(){
		$(".slideshow__slide").each(function(){
			if($(this).find(".slideshow__video").length != 0){
				//video in this slide

				var $thisSlide = $(this),
				$thisVideo = $(this).find(".slideshow__video"),
				$thisid = $thisVideo.attr("id"),
				$thisurl = $thisVideo.attr("data-video-url"),
				$thisvidid = $thisVideo.attr('data-id'),
				$thistype = $thisVideo.attr('data-type');
	      $thisbgvideo = $('.background-video');
				if($thisurl == "youtube"){
	    			var vid = '<iframe src="//www.youtube.com/embed/' + $thisvidid + '?controls=1" width="560" height="315" frameborder="0" allowfullscreen></iframe>';
		    	}else{
	    			var vid = '<iframe src="//player.vimeo.com/video/' + $thisvidid + '" width="560" height="315" frameborder="0" allowfullscreen></iframe>';
		    	}

					if($thisbgvideo.length > 0 ){
						if($thisurl == "youtube"){
			    			var bgvid = '<iframe src="//www.youtube.com/embed/' + $thisvidid + '?autoplay=1&controls=0&mute=1" width="' + $(window).width() + '" height="' + $(window).width()/16*9 + '" frameborder="0" allowfullscreen autoplay></iframe>';
				    	}else{
			    			var bgvid = '<iframe src="//player.vimeo.com/video/' + $thisvidid + '?autoplay=1&controls=0&mute=1" width="560" height="315" frameborder="0" allowfullscreen> autoplay</iframe>';
				    	}

							$thisbgvideo.html(bgvid);
					}

		    	$thisVideo.html(vid);

		    	$(this).find(".slideshow__video-control--play").on("click",function(){
		    		$thisSlide.addClass("video-is-playing");
		    		return false;
		    	})

		    	$(this).find(".slideshow__video-control--close").on("click",function(){
		    		$thisSlide.removeClass("video-is-playing");
		    		return false;
		    	});

			}
		});
	}

	function init(){
		slickRender();
		videoSlide();
	}

	init();

	return {
		sliderSettings: getSliderSettings
	}

})();

theme.SlideshowSection = function SlideshowSection() {};

theme.SlideshowSection.prototype = $.extend({}, theme.SlideshowSection.prototype, {
	onBlockSelect: function(e){
		var blockId     = parseInt(e.detail.blockId),
		    $blockClass = $('.slideshow__slide--' + blockId),
		    slideIndex  = $blockClass.attr('data-slick-index');
		$('.slideshow').slick("goTo", slideIndex);
	},
  onSelect: function() {
	  $('.slideshow').slick(theme.Slideshow.sliderSettings());
  }
});
theme.Testimonials = (function() {

	$('.quotes-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		dots:true
	});

})();
theme.CollectionSlider = (function() {

	$('.collection-carousel').slick({
		arrows:true,
		vertical:false,
		prevArrow: '<div class="slick-arrow slick-prev"> < </div>',
		nextArrow: '<div class="slick-arrow slick-next"> > </div>',
	  	responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		        infinite: true,
		        dots: true
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
	  	]
	});

})();
theme.Collection = (function() {

	$('.collection-grid-item__match-height').matchHeight();
	
})();



theme.ProductSlider = (function() {

	$('.main-product-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true
	});

	$('.product-slider-nav').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.main-product-slider',
		dots: false,
		arrows:true,
		centerMode: true,
		focusOnSelect: true,
		vertical:false,
    	verticalSwiping: false,
	});
})();



theme.Swatch = (function() {

	var $swatch = $('.swatch-product');

  	$swatch.on('click', swatchChange);

  	function swatchChange() {
  		var $this       = $(this),
			swatchValue = $this.attr('data-swatch-value');

			$('.selector-wrapper--colour select').val(swatchValue).trigger('change');

 	}

})();



theme.Accordion = (function() {

	var $title      = $(".accordion__title"),
		$content    = $('.accordion__content'),
		activeClass = 'accordion__content--is-active',
		activeClassParent = 'accordion__item--is-active';
	

	$title.bind('click', accordionOpen);

	function accordionOpen(){
		var $this = $(this);
			toggleData = $this.attr('data-toggle');

		$content.removeClass(activeClass);
		$content.parent().removeClass(activeClassParent);
		$('#'+toggleData).addClass(activeClass);
		$('#'+toggleData).parent().addClass(activeClassParent);
	}

})();



theme.NotificationBar = (function() {

	var $notificationBar = $('.notification-bar--carousel');

	$notificationBar.slick(getSliderSettings());

  function getSliderSettings(){
	  return {
	    arrows:true,
			vertical:false,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: '<div class="slick-arrow slick-prev"> < </div>',
			nextArrow: '<div class="slick-arrow slick-next"> > </div>',
	  }
	}

	return {
		sliderSettings: getSliderSettings
	}

})();

theme.NotificationBarSection = function NotificationBarSection() {};

theme.NotificationBarSection.prototype = $.extend({}, theme.NotificationBarSection.prototype, {
	onBlockSelect: function(e){
		var blockId     = parseInt(e.detail.blockId),
		    $blockClass = $('.notification-bar-' + blockId),
		    slideIndex  = $blockClass.attr('data-slick-index');
		$('.notification-bar--carousel').slick("goTo", slideIndex);
	},
  onSelect: function() {
	  $('.notification-bar--carousel').slick(theme.NotificationBar.sliderSettings());
  }
});
theme.InstagramFeed = (function() {

	return false;
	
	if($("#instafeed").attr("data-user-id") != ""){
		var myuserid = $("#instafeed").attr("data-user-id"),
		myaccesstoken = $("#instafeed").attr("data-access-token"),
		userFeed = new Instafeed({
	        get: 'user',
	        userId: myuserid, //Put The user id here..
	        accessToken: myaccesstoken, //Put The access token here..
	        resolution:'standard_resolution',
	        limit: '12',
	      	template: '<div class="grid__item medium-up--one-sixth"><a class="insta_img"  target="_blank" href="\{\{link\}\}" style="background-image: url\(\{\{image\}\}\)"><span class="inner"><span class="inner-text">{{caption}}</span></span></a></div>'
	    }); 
	    console.log(myuserid + " " +myaccesstoken);
	    userFeed.run();
	}
})();
theme.AjaxCart = (function() {

  if (theme.ajaxCart == false) {
    console.log('false');
    return false;
  }

  var selectors = {
    $form            : $('form[action="/cart/add"]'),
    $cartCount       : $('#CartCount, .cart-ajax__subtitle-counter'),
    $cartList        : $('.cart-ajax__list'),
    $cartBody        : $('.cart-ajax__wrapper'),
    $cartTotalPrice  : $('.cart-ajax--total-price'),
    $cartClose       : $('.cart-ajax__close'),
	  $cartToggleBtn   : $('#Cart-icon')
  };

  var storeCurrency = 'amount',
			cartOpened = false,
     	cartPage   = window.location.pathname;

  /* ----------------------------------------------------
  Add to cart functions
  -----------------------------------------------------*/ 
  selectors.$form.on('submit', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

    var $this         = $(this),
        formData      = $this.serialize(),
        $error        = $this.find('.error');
        addToCart(formData, $error);
  });

  /* ----------------------------------------------------
  change cart functions and triggers
  -----------------------------------------------------*/ 
  $(document).on('click', '.cart-ajax__remove', function(event){
    var $this     = $(this);
    cartValueTrigger($this, 'remove');
  });

  $(document).on('focusout', '.cart-ajax .quantity-wrapper input', function(event){
    var $this = $(this);
    cartValueTrigger($this);
  });

  $(document).on('click', '.cart-ajax .quantity-wrapper', function(event){
    var $this = $(this);
    cartValueTrigger($this);
  });

  function cartValueTrigger(element, remove){
    var $this        = element,
        variantId    = $this.closest('.cart-data').attr('data-id'),
        lineNo       = $this.closest('.cart-data').attr('data-line'),
        input        = $this.parent().find('input'),
        sendQuantity = parseInt(input.val());

        if (remove == 'remove'){
          var sendQuantity = 0;
        }

    changeCart(lineNo, sendQuantity, variantId);
  }

  /* ----------------------------------------------------
  Cart open and close functions
  -----------------------------------------------------*/
  selectors.$cartToggleBtn.on('click', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    cartRender();
  });

  $(document).on('mouseup', function(event){
    if (!selectors.$cartBody.is(event.target) && selectors.$cartBody.has(event.target).length === 0){ 
      cartClose();
    }
  });

  selectors.$cartClose.on('click', function(){
  	cartClose();
  });


  /* ----------------------------------------------------
  Below are all the functions for Add to cart, update cart and get cart data
  -----------------------------------------------------*/

  function addToCart(formData, $error){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      beforeSend: function(){
        $error.addClass('error--hide');
      },
      success: function(response){ 
        cartRender();
        $error.html('Added to Cart').removeClass('error--hide');
      },
      error: function(XMLHttpRequest, textStatus) {
        var data     = eval('(' + XMLHttpRequest.responseText + ')'),
            response = data.description;

        $error.html(response).removeClass('error--hide');
      }
    })
  }

  function changeCart(lineNo, quantity, variantId){
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + lineNo,
      dataType: 'json',
      beforeSend: function(response){
        // if( quantity == 0 && cartPage === '/cart') {
        //   $('.cart__row--' + variantId).fadeOut().remove();
        // }
      },
      success: function(response){ 
        cartRender();
      }
    })
  }
 
  function getCartJSON(callback, x, y) {
    jQuery.getJSON('/cart.js', function (cart) {
      callback(cart, x, y);
    });
  };

  /* ----------------------------------------------------
  Below are all the functions update the cart display - Ajax and cart page
  -----------------------------------------------------*/
  function cartRender() {
    if (cartPage === '/cart') {
      // getCartJSON(updateCartTotal);
      // getCartJSON(updateLineItems);
    } else  {
      getCartJSON(cartBuild);
      if( cartOpened != true ){ 
        cartOpen();
      }
    }
    getCartJSON(cartCounter);
  };


  // Ajax Cart Open
  function cartOpen() {
    selectors.$cartBody.addClass('cart-ajax--show');
    cartOpened = true;
  };

  // Ajax Cart Close
  function cartClose(){
    selectors.$cartBody.removeClass('cart-ajax--show');
    cartOpened = false;
  }

  function cartCounter(cart) {
    selectors.$cartCount.html(cart.item_count);
    if (cart.item_count != 0){
      selectors.$cartCount.addClass('cart-count--show');
    } else{
      selectors.$cartCount.removeClass('cart-count--show');
    }
  };

  function cartBuild(cart) {

    items     = cart.items,
    cartTotal = slate.Currency.formatMoney(cart.total_price);

    selectors.$cartList.html('');
    selectors.$cartTotalPrice.html('<span class=money>'+cartTotal+'</span>');

    $.each(items, function(i, item){

      let cartRow = createMarkup(item, i);
      selectors.$cartList.append(cartRow);

    });

  };

  function createMarkup(cart, loopCount) {

    var cartVariantTitle = cart.variant_title != null ? cart.variant_title : '' ,
        cartVariantPrice = slate.Currency.formatMoney(cart.price),
        cartLinePrice    = slate.Currency.formatMoney(cart.line_price),
        loopCounter      = loopCount + 1;


    var cartRow = '<div class="cart-ajax__row cart-data" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<small class="cart-ajax__row__variant">' + cartVariantTitle + '</small> </a> <span class="cart-ajax__row__money"' + cartLinePrice + '</span><span class="cart-ajax__row__unit-price">' + cartVariantPrice + '</span><div class="quantity-wrapper"><div class="quantity-wrapper__minus js--quantity" data-increment="false">-</div><input type="number" value="' + cart.quantity + '" min="0"><div class="quantity-wrapper__plus js--quantity" data-increment="true">+</div></div><div class="cart-ajax__remove"></div></div></div>';

    return cartRow;
	}

  // Cart Page
  function updateCartTotal(cart){
    // selectors.$subTotalClass.html( moneyFormatter.format(storeCurrency, (cart.total_price/100)) );
    // selectors.$cartItems.html(cart.item_count);
  }

  function updateLineItems(cartdata){
    // $.each(cartdata.items, function(i, item){

    //   var linePrice    = moneyFormatter.format(storeCurrency, (item.original_line_price/100)),
    //       lineQuantity = item.quantity,
    //       newLineData  = i + 1;

    //     $('.cart__row--' + item.id + ' .cart__line-total').html(linePrice)
    //     $('.cart__row--' + item.id + ' .cart-ajax__quantity__input').val(lineQuantity)
    //     $('.cart__row--' + item.id + ' .cart-data').attr('data-line', newLineData);
    // });
  }
 
})();
theme.Quantity = (function() {

    $(document).on('click', '.js--quantity', function(e){
      e.preventDefault();
      var $input       = $(this).parent().find('input'),
          inputVal     = parseInt($input.val()),
          sendQuantity = 0,
          incrementBoo = $(this).attr('data-increment'),
          increment    = incrementBoo.toString();

      if( increment == 'true' ){
        var newVal = inputVal+1;
        $input.val(newVal);
      } else {
        if(inputVal-1 != 0){
          var newVal = inputVal-1;
          $input.val(newVal);
        }
      }
    });

})();
theme.Video = (function() {

	$('.video-block__image').on('click', function(ev) {

    var autoplay = "";

    $(this).parent().closest('.video-block').addClass("active");

    if ($(this).parent().find(".video.vimeo")[0]){
      autoplay = "&autoplay=1";
    } 
    else if ($(this).parent().find(".video.youtube")[0]){
      autoplay = "?autoplay=1";
    }

    $(this).parent().find(".video")[0].src += autoplay;
    ev.preventDefault();

  });
    

})();
theme.Logos = (function() {

	$('html, body').scrollLeft(0);

  
	  var display1 = $(".logos--logo"),
	  offsetWidth = $(".site-nav").offset().left + 10,
	  introPostWidth = $(".logos--intro-post").width()-36;

	  display1.each(function(i){
	  	$(this).find(".logo--logo-meta").css("z-index",i);
	  })
	

  	function displayLogoCaption (x, y){
	    var element         = x,
	        scrollDistance  = $(window).scrollLeft();
	    x.each( function( i, item ){
	      var currentElement = $(item),
	      	  previousItem = x.eq(i-1),
	      	  nextItem = x.eq(i+1),
	          currentElementOffset = currentElement.offset().left - y;

	      if (scrollDistance > currentElementOffset){
	        currentElement.addClass('display-caption');
	        previousItem.removeClass('display-caption');
	        nextItem.removeClass('display-caption');
	      }
		  	if(scrollDistance<introPostWidth){
		  		//before the first logo
		      	x.removeClass('display-caption');
		    }
	    });
	}

	var windowSize = $(window).width();
	if(windowSize>700){
		$(".logos--main").css("padding-right",$(window).width());
		  $(window).scroll(function() {
		    displayLogoCaption(display1, offsetWidth);
		  });
	}
  
  $(window).resize(function() {  
  	var windowSize = $(window).width();
  	if(windowSize>700){
  		$(".logos--main").css("padding-right",$(window).width());
  		  $(window).scroll(function() {
		    displayLogoCaption(display1, offsetWidth);
		  });
  	}

  });


function resized(){
    // Haven't resized in 100ms!
    console.log("reloading");
    //location.reload();
    window.location.href = window.location.href.replace( /[\?#].*|$/, "?start" );

}

if (window.innerWidth > 900) {
  var doit;
  window.onresize = function(){
    clearTimeout(doit);
    doit = setTimeout(function(){
      console.log("reloading");
      window.location.href = window.location.href.replace(/[\?#].*|$/, "?start");
    }, 100);
  };
}


  

})();
theme.GalleriaSlideshow = (function() {


	var $slideshow = jQuery('.slideshow-galleria');
	var windowsize = jQuery(window).width();
	if(windowsize>690){
    	imgCrop = "true";
    }else{
        imgCrop = "false";
    }
	imgPos = 'center center';


	function startGalleria(imgCrop,imgPos){
		Galleria.configure({
		    show_counter: false,
	        transition:'fade',
	        responsive:true,
	        thumbnails:false,
	        autoplay:3000,
	        transitionSpeed: 4000,
	        imageCrop:imgCrop,
	        imagePosition:imgPos,
	        imageMargin:0,
	        touchTransition:'fade',
	        initialTransition:'fade'
		});

		Galleria.run('.slideshow-galleria',{
			extend: function() {
	            this.bind("loadstart", function(e) {
	                $(".gallery-caption").fadeTo(0, 0); 
	            });
	            this.attachKeyboard({
			        left: this.prev,
			        right: this.next
			    });
	           	this.bind("loadfinish", function(e) {	                
	                    var gallery = Galleria.get(0); 
						var imageSrc = e.galleriaData.image;

	                    if(imageSrc.indexOf("_right") != -1){
	                        $(".gallery-caption").addClass("right");
	                    }else{
	                        $(".gallery-caption").removeClass("right");
	                    }
	                    if(imageSrc.indexOf("_white") != -1){
	                        $("body").delay(1500).addClass("white");
	                    }else{
	                        $("body").delay(1500).removeClass("white");
	                    }
	                                        
	                    var thisdescription = e.galleriaData.description
	                    if(thisdescription != ""){
	                    	$('.caption-header').html(e.galleriaData.title);
	                    	$('.caption-footer').html(e.galleriaData.description);
	                        $(".gallery-caption").fadeTo( 3000, 1 ); 
	                    }else{
	                        $(".gallery-caption").fadeOut(500);
	                        $('.caption-header').html();
	                    	$('.caption-footer').html();
	                    }
	            });
	            
	        }
		});

	}
  
  
  function startMobileGalleria(imgCrop,imgPos){
		Galleria.configure({
		    show_counter: false,
	        transition:'fade',
	        responsive:true,
	        thumbnails:false,
	        autoplay:false,
	        transitionSpeed: 4000,
	        imageCrop:true,
          	swipe:true,
	        imagePosition:'center top',
	        imageMargin:0
		});

		Galleria.run('.gallery-group',{
			extend: function() {
	            
	            this.attachKeyboard({
			        left: this.prev,
			        right: this.next
			    });
	           	this.bind("loadfinish", function(e) {	                
                  var gallery = Galleria.get(0); 
                  var imageSrc = e.galleriaData.image;

                  if(imageSrc.indexOf("_white") != -1){
                      $("body").delay(1500).addClass("white");
                    	this.$('container').addClass("white");
                  }else{
                      $("body").delay(1500).removeClass("white");
                    	this.$('container').removeClass("white");
                  }	 
                  var thisdescription = e.galleriaData.description
                  var thisgallery = this.$('container').parent().attr("data-gallery");
                  if(thisdescription != ""){
                   	var title = e.galleriaData.title,
                        description = e.galleriaData.description;
                    title = title.replace(/<br\s*[\/]?>/gi, "\n");
                    description = description.replace(/<br\s*[\/]?>/gi, "\n");
                    

                     $('.mobile-caption[data-gallery="'+thisgallery+'"] .caption-header').html(title);
                     $('.mobile-caption[data-gallery="'+thisgallery+'"] .caption-footer').html(description);
                     $('.mobile-caption[data-gallery="'+thisgallery+'"]').fadeTo( 3000, 1 ); 
                  }else{
                    $('.mobile-caption[data-gallery="'+thisgallery+'"]').fadeOut(500);
                    $('.mobile-caption[data-gallery="'+thisgallery+'"] .caption-header').html();
                    $('.mobile-caption[data-gallery="'+thisgallery+'"] .caption-footer').html();
                  }
	            });
	           	
	            
	        }
		});

	}

	if(jQuery("body").hasClass("template-index")){
		//console.log("test");
		
      	if(windowsize<700){
          startMobileGalleria(imgCrop,imgPos);
        }else{
          startGalleria(imgCrop,imgPos);
        }
	}
      

})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__left, .login__right').toggleClass('hide');
    $('.recover_wrapper').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product');
  sections.register('slideshow', theme.SlideshowSection);
  sections.register('notification-bar', theme.NotificationBarSection);
  sections.register('meganav', theme.MeganavSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
